var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.Visible)?_c('div',{staticClass:"message_warpper",class:_vm.Type,style:('transform: translate(-50%,'+parseFloat(_vm.informCount*150-200)+'%);')},[_vm._v(_vm._s(_vm.Message))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }